import { CLEAR_REDEMPTION_LIST, GET_REDEMPTION_LIST } from "../actions/type";

const initialState = {
    data: [],
};

const Redemption = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_REDEMPTION_LIST:
            return {
                ...state,
                data: payload,
            };
        case CLEAR_REDEMPTION_LIST:
            return {
                ...state,
                data: [],
            };

        default:
            return state;
    }
};
export default Redemption;
